
import React from 'react'
import PropTypes from 'prop-types'
import TempResponsiveScreen from '@components/TempResponsiveScreen'


class RecordingPlayer extends TempResponsiveScreen {
  static propTypes = {
    type: PropTypes.oneOf(["video/mp4", "audio/mp4"]).isRequired,
    streamUrl: PropTypes.string.isRequired,
    transcriptUrl: PropTypes.string,
    playerSize: PropTypes.object.isRequired // { width, height }
  }

  render() {
    const { type, streamUrl, transcriptUrl, playerSize } = this.props
    if (!type || !streamUrl || !playerSize) return null

    const playerClassName = type.includes('video') ? 'video' : 'audio'

    return (
      <div className='video-container'>
        {playerClassName === 'video' ?
          (
            <video crossorigin="anonymous" key={streamUrl} className={playerClassName} width={playerSize.width} height={playerSize.height} controls>
              <source src={streamUrl} type={type} />
              {(playerClassName === 'video' && transcriptUrl) && <track default src={transcriptUrl} />}
              Your browser doesn't support this video format.
            </video>
          )
          :
          (
            <audio crossorigin="anonymous" key={streamUrl} className={playerClassName} width={playerSize.width} height={playerSize.height} controls>
              <source src={streamUrl} type={type} />
              Your browser doesn't support this audio format.
            </audio>
          )
        }
      </div>
    )
  }
}

export default RecordingPlayer

